import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminApi, setToken, getToken } from "./api";

const Ctx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=signed-in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      setLoading(false);
      return;
    }
    adminApi
      .me()
      .then((r) => setUser(r.data))
      .catch(() => {
        setToken(null);
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await adminApi.login(email, password);
    setToken(data.access_token);
    setUser({ email, must_change_password: data.must_change_password });
    return data;
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(false);
  }, []);

  const refreshMe = useCallback(async () => {
    const { data } = await adminApi.me();
    setUser(data);
    return data;
  }, []);

  const applyToken = useCallback((token, must_change_password, email) => {
    setToken(token);
    setUser({ email: email ?? user?.email, must_change_password });
  }, [user]);

  return (
    <Ctx.Provider value={{ user, loading, login, logout, refreshMe, applyToken }}>
      {children}
    </Ctx.Provider>
  );
}

export function useAdminAuth() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useAdminAuth must be used inside AdminAuthProvider");
  return v;
}
